import noFamilyFound from "../../assets/images/svg/nofamilyfound.svg";
import React, { useEffect, useRef, useState } from "react";
import CardContact from "../CardContact/CardContact";
import contactPhone from "../../assets/images/svg/contactPhone.svg";
import contactEmail from "../../assets/images/svg/contactEmail.svg";
import contactLandline from "../../assets/images/svg/contactLandline.svg";
import contactAddress from "../../assets/images/svg/contactAddress.svg";
import settingPhone2 from "../../assets/images/svg/settingPhone2.svg";
import excu_acc from "../../assets/images/png/excu_acc.png";
import account_registered from "../../assets/images/png/account_registered.png";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import upArrowBlack from "../../assets/images/svg/upArrowBlack.svg";
import settingMail3 from "../../assets/images/svg/settingMail3.svg";
import infoIcon from "../../assets/images/svg/info.svg";
import NoImage from "../NoImage/NoImage";
import defaultImgForLiasionAccess from "../../assets/images/svg/defaultImgForLiasionAccess.svg";
import imageIcon from "../../assets/images/svg/imageIcon.svg";
import Modal from "../Modal";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from "../Accordion/Accordion";
import Tabs from "../Tabs";
import CircularProressBar from "../CircularProgressBar/CircularProressBar";
import AToZ from "../AToZ";
import ArrowButton from "../ArrowButton";
import {
  findAmc,
  findBank,
  getAccountNum,
  getAccountsLength,
  getbroker,
  getDecodedToken,
  getDisplayDate,
  getNameWithInitials,
} from "../../utils/functions";
import { observer } from "mobx-react-lite";
import SortArray from "../../utils/Hooks/SortArray";
import SearchButton2 from "../SearchButton2/SearchButton2";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import ProfileStore from "../../store/ProfileStore";
import ProfileStore2 from "../../store/ProfileStore2";
import UserStore from "../../store/UserStore";
import { getCookie } from "../../utils/cookie";
import PerformanceStore from "../../store/PerformanceStore";
import UploadProfileTooltip from "../Tooltip/UploadProfileTooltip";
import { familyOfficeTeamNameText } from "../../utils/constants";

const ProfileDetails = ({
  currentOpenAccordion,
  handleAccordion,
  data,
  contactDetails,
  la_officer,
  bankDetails,
  selectedUser,
  setSelectedSet,
  userDetais,
  setCurrenAccordionObject,
  currenAccordionObject,
}) => {
  const [removePhotoModal, setRemovePhotoModal] = useState(false);
  const [isPictureUpdating, setIsPictureUpdating] = useState(false);
  const [isPicUpdateApiCalled, setIsPicUpdateApiCalled] = useState(false);
  const [nomineeAccordionOpenIndex, setNomineeAccordionOpenIndex] = useState(
    [],
  );
  const [isTab, setIsTab] = useState(false);
  const [uploadPictureModal, setUploadPictureModal] = useState(false);
  const [uploadMessage, setUploadMessage] = useState({
    message: "",
    isError: false,
  });
  const [isPicFlowUpdate, setPicUpdateFlow] = useState(false);

  const [isUploadSuccess, setIsUploadSuccess] = useState(false);

  const getFirstTab = (data) => {
    return data?.bankAccountsList.length !== 0
      ? "bankAccount"
      : data?.dematAccountsList.length !== 0
        ? "dematAccount"
        : data?.foliosList.length !== 0
          ? "mfFolios"
          : data?.loansList.length !== 0
            ? "loan"
            : data?.pmS_Accounts.length !== 0
              ? "pmsFolios"
              : data?.aiF_Folios.length !== 0
                ? "aiF_Folios"
                : "";
  };

  const handleToggleAccordion = (accordionId, idx, rowData) => {
    setNomineeAccordionOpenIndex([]);
    const tab = getFirstTab(rowData);

    // new added code
    setCurrenAccordionObject((prev) => {
      return {
        ...prev,
        [accordionId]: {
          selectedTab: {
            tab: `${idx}${accordionId}${tab}`,
            index: idx,
          },
        },
      };
    });

    handleAccordion(accordionId);

    if (currenAccordionObject[accordionId] !== undefined) {
      let objectData = currenAccordionObject;
      delete objectData[accordionId];

      setCurrenAccordionObject(objectData);
      handleAccordion(null);
    }
  };

  const BankAccountAccordionContent = ({ data }) => {
    return data?.length !== 0 ? (
      <div className="bank_account_content">
        {data?.map((card) => (
          <div className="bank_account_card" style={{ cursor: "unset" }}>
            <div className="bank_name_logo">
              <div className="bank_logo">
                <img
                  src={findBank(
                    card.ifsc_code ? card.ifsc_code.substring(0, 4) : "",
                  )}
                  alt="logo"
                />
              </div>
              <div className="bank_name_address">
                <p className="bank_name">{card?.bank_name}</p>
                <p className="bank_address blueTextColor">{card?.branch}</p>
              </div>
            </div>
            <div className="account_type_number">
              <p className="account_type blueTextColor">{`${card?.type} ACCOUNT`}</p>
              <p className="account_number">
                {getAccountNum(card?.account_no)}
              </p>
            </div>
            <div className="account_codes">
              <div className="micr_code_wrapper">
                <p className="micr_code_text blueTextColor">MICR Code</p>
                <p className="micr_code">{card?.micr_code}</p>
              </div>
              <div className="ifsc_code_wrapper">
                <p className="ifsc_code_text blueTextColor">IFSC Code</p>
                {card?.ifsc_code ? (
                  <p className="ifsc_code">{card?.ifsc_code}</p>
                ) : (
                  <p className="hide">NO Data</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <EmptyContent title={"bank account linked"} />
    );
  };

  const DematAccountAccordionContent = ({ data }) => {
    const handleToggleSubAccordion = (subAccordionId, acc_code) => {
      let arr = [...nomineeAccordionOpenIndex];
      if (nomineeAccordionOpenIndex.includes(subAccordionId)) {
        const index = nomineeAccordionOpenIndex.indexOf(subAccordionId);
        if (index > -1) arr.splice(index, 1);
      } else arr.push(subAccordionId);
      setNomineeAccordionOpenIndex([...arr]);

      if (
        currenAccordionObject[acc_code]?.selectedTab?.[
          `${subAccordionId}${acc_code}`
        ]
      ) {
        let objectData = currenAccordionObject;
        delete objectData?.[acc_code]?.selectedTab?.[
          `${subAccordionId}${acc_code}`
        ];
        setCurrenAccordionObject(objectData);
      } else {
        setCurrenAccordionObject((prevState) => {
          return {
            ...prevState,
            [acc_code]: {
              selectedTab: {
                ...currenAccordionObject[acc_code].selectedTab,
                [`${subAccordionId}${acc_code}`]: true,
              },
            },
          };
        });
      }
    };

    return data?.length !== 0 ? (
      <div className="demat_account_content">
        {data?.map((data, index) => (
          <Accordion>
            <AccordionHeader>
              <div className="demat_acc_sub_accordion_header">
                <div className="demat_acc_broker_name_wrapper">
                  <img
                    src={getbroker(data?.depository_name)}
                    alt="broker logo"
                  />

                  <div className="broker_name">
                    {data?.company_name?.length > `${!isTab ? 15 : 10}` ? (
                      <>
                        <p>{`${data.company_name?.slice(
                          0,
                          `${!isTab ? 15 : 10}`,
                        )}...`}</p>
                        <div className="info_icon_tooltip">
                          <img
                            className="info_img clickable"
                            src={infoIcon}
                            alt="info"
                          />
                          <p className="td_tooptip">{data?.company_name}</p>
                        </div>
                      </>
                    ) : (
                      data?.company_name
                    )}
                  </div>
                </div>
                <div className="dp_name_wrapper">
                  <p className="dp_name_text blueTextColor">DP Name </p>
                  <p className="dp_name_detail">
                    {data?.depository_name?.length > 14
                      ? `${data?.depository_name?.slice(0, 14)}...`
                      : data?.depository_name}
                  </p>
                  {data?.depository_name?.length > 14 && (
                    <img
                      className="info_icon clickable"
                      src={infoIcon}
                      alt="info"
                    />
                  )}
                </div>
                <div className="dp_id_wrapper2 dp_id_min_width">
                  <p className="dp_id_text blueTextColor">DP ID </p>
                  <p className="dp_id">{data?.id}</p>
                </div>
                <div className="dp_id_wrapper2 client_id_min_width">
                  <p className="dp_id_text blueTextColor">Client ID </p>
                  <p className="dp_id">{data?.dp_client_id}</p>
                </div>
                <div className="nominee_toggle_btn_wrapper">
                  <div className="nominiees_wrapper">
                    <p className="nominiees_text blueTextColor">Nominees</p>
                    <p className="nominiees_number">{`(${data?.nomineeList?.length})`}</p>
                  </div>
                  {data?.nomineeList?.length !== 0 ? (
                    <div
                      className="toggle_btn_bg buttonBlueBorder"
                      onClick={() =>
                        handleToggleSubAccordion(index, data?.accountcode)
                      }
                    >
                      <img
                        src={
                          currenAccordionObject[data?.accountcode]
                            ?.selectedTab?.[`${index}${data?.accountcode}`]
                            ? upArrowBlack
                            : downArrowBlack
                        }
                        alt="toggle"
                      />
                    </div>
                  ) : (
                    <div className="toggle_hidden"></div>
                  )}
                </div>
              </div>
            </AccordionHeader>
            {data?.nomineeList?.length !== 0 && (
              <AccordionContent
                open={nomineeAccordionOpenIndex?.includes(index)}
              >
                <div className="demat_acc_sub_accordion_content">
                  {data?.nomineeList?.map((nominee, index) => (
                    <div className="person_card">
                      <p className="person_name">{nominee?.name}</p>
                      <CircularProressBar
                        percentage={
                          !/[1-9]/.test(nominee?.percentage?.split(".")?.[1])
                            ? Number(nominee?.percentage)?.toFixed()
                            : nominee?.percentage
                        }
                      />
                    </div>
                  ))}
                </div>
              </AccordionContent>
            )}
          </Accordion>
        ))}
      </div>
    ) : (
      <EmptyContent title={"demat acoount linked"} />
    );
  };

  const LoanAccordionContent = ({ data }) => {
    return data?.length !== 0 ? (
      <div className="loan_content">
        {data?.map((card, index) => (
          <div className="loan_card">
            <div className="loan_heading">
              {getNameWithInitials(card?.product_name)}
            </div>
            <div className="loan_las_number_wrapper">
              <p className="loan_las_number_text">LAS Account Number</p>
              <p className="loan_las_number">
                {card?.loan_account_number && card?.loan_account_number}
              </p>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <EmptyContent title={"loan account linked"} />
    );
  };

  const PMSFoliosAccordionContent = ({ data, title }) => {
    const [isSort2, setSort2] = useState("asc");
    const [pmsSearch, setPmsSearch] = useState("");
    const arr = data?.filter((eachData) => true);
    const { arrData, setIsAsscending } = SortArray(arr, "product_name");
    const newStr = data?.reduce((acc, curr) => {
      return acc + curr?.nomineeList?.length;
    }, "");
    const noNominee = /[1-9]/.test(newStr);

    const handleToggleSubAccordion = (subAccordionId, acc_code) => {
      if (
        currenAccordionObject[acc_code]?.selectedTab?.[
          `${subAccordionId}${acc_code}`
        ]
      ) {
        let objectData = currenAccordionObject;
        delete objectData?.[acc_code]?.selectedTab?.[
          `${subAccordionId}${acc_code}`
        ];
        setCurrenAccordionObject(objectData);
      } else {
        setCurrenAccordionObject((prevState) => {
          return {
            ...prevState,
            [acc_code]: {
              selectedTab: {
                ...currenAccordionObject[acc_code].selectedTab,
                [`${subAccordionId}${acc_code}`]: true,
              },
            },
          };
        });
      }
    };

    return data?.length !== 0 ? (
      <div className="pms_folios_content">
        <div className="pms_folio_filter_search_container">
          <div
            className="filter_container"
            onClick={() => {
              switch (isSort2) {
                case "asc":
                  setSort2("desc");
                  setIsAsscending(false);
                  break;
                case "desc":
                  setSort2("asc");
                  setIsAsscending(true);
                  break;
                default:
                  setSort2("desc");
                  break;
              }
            }}
          >
            <AToZ fontSize="12px" isSort={isSort2} arrowHeight="arrowHeight" />
          </div>

          <div className="search_bar_container">
            <SearchButton2
              search={pmsSearch}
              setSearch={(data) => setPmsSearch(data)}
              classes={"search_btn_out2"}
              closeBtn={"small"}
            />
          </div>
        </div>
        <div className="pms_folios_sub_accordions">
          {arrData?.filter((eachData) =>
            eachData?.product_name
              ?.toLowerCase()
              ?.includes(pmsSearch?.toLowerCase()?.trim()),
          )?.length !== 0 ? (
            arrData
              ?.filter((eachData) =>
                eachData?.product_name
                  ?.toLowerCase()
                  ?.includes(pmsSearch?.toLowerCase()?.trim()),
              )
              ?.map((data, index) => (
                <Accordion>
                  <AccordionHeader>
                    <div className="demat_acc_sub_accordion_header">
                      <div className="demat_acc_broker_name_wrapper">
                        <div className="folios_image_wrapper">
                          <img src={findAmc(data?.amc_id)} alt="broker logo" />
                        </div>
                        <p className="broker_name">{data?.product_name}</p>
                      </div>
                      <div className="right_side_data">
                        <div className="dp_id_wrapper">
                          <p className="dp_id_text blueTextColor">
                            Folio Number
                          </p>
                          <p className="dp_id">{data?.folio_number}</p>
                        </div>
                        {data?.nomineeList ? (
                          <div className="nominee_toggle_btn_wrapper">
                            <div className="nominiees_wrapper">
                              <p className="nominiees_text">Nominees</p>
                              <p className="nominiees_number">{`(${
                                !data?.nomineeList
                                  ? 0
                                  : data?.nomineeList?.length
                              })`}</p>
                            </div>
                            {!data?.nomineeList ||
                            data?.nomineeList === undefined ? (
                              <div className="toggle_hidden"></div>
                            ) : data?.nomineeList.length !== 0 ? (
                              <div
                                className="toggle_btn_bg buttonBlueBorder"
                                onClick={() =>
                                  handleToggleSubAccordion(
                                    index,
                                    data?.accountcode,
                                  )
                                }
                              >
                                <img
                                  src={
                                    currenAccordionObject[data?.accountcode]
                                      ?.selectedTab?.[
                                      `${index}${data?.accountcode}`
                                    ]
                                      ? upArrowBlack
                                      : downArrowBlack
                                  }
                                  alt="toggle"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          <div
                            className={!noNominee ? "none" : "minWidth"}
                          ></div>
                        )}
                      </div>
                    </div>
                  </AccordionHeader>
                  <AccordionContent
                    open={
                      currenAccordionObject[data?.accountcode]?.selectedTab?.[
                        `${index}${data?.accountcode}`
                      ]
                    }
                  >
                    <div className="demat_acc_sub_accordion_content">
                      {data?.nomineeList?.map((nominee, index) => (
                        <div className="person_card">
                          <p className="person_name">{nominee?.name}</p>
                          <CircularProressBar
                            percentage={nominee?.percentage}
                          />
                        </div>
                      ))}
                    </div>
                  </AccordionContent>
                </Accordion>
              ))
          ) : (
            <div className="empty_search">
              {" "}
              <img src={noFamilyFound} alt="no_data" /> <h2>No Data Found</h2>
            </div>
          )}
        </div>
      </div>
    ) : (
      <EmptyContent title={title} />
    );
  };

  const MFFoliosAccordionContent = ({ data }) => {
    const [isSort, setSort] = useState("asc");
    const holdingsData = data?.filter((datas) => datas.withholdings);
    const withoutHolding = data?.filter((datas) => !datas.withholdings);
    const { arrData: withHoldData, setIsAsscending: setOrder } = SortArray(
      holdingsData,
      "amc_manufacturer",
    );
    const { arrData: withoutHoldData, setIsAsscending: setwithoutOrder } =
      SortArray(withoutHolding, "amc_manufacturer");

    const newStr = data?.reduce((acc, curr) => {
      return acc + curr?.nomineeList?.length;
    }, "");

    const noNominee = /[1-9]/.test(newStr);

    const [subTab, setSubTab] = useState({
      tab: "with_hold",
      isSelected: true,
    });
    const [mfSearch, setMfSearch] = useState("");
    const handleSubTab = (value) => {
      setSubTab({ tab: value, isSelected: !subTab.isSelected });
    };

    const handleToggleSubAccordion = (subAccordionId, acc_code) => {
      if (
        currenAccordionObject[acc_code]?.selectedTab?.[
          `${subAccordionId}${acc_code}`
        ]
      ) {
        let objectData = currenAccordionObject;
        delete objectData?.[acc_code]?.selectedTab?.[
          `${subAccordionId}${acc_code}`
        ];
        setCurrenAccordionObject(objectData);
      } else {
        setCurrenAccordionObject((prevState) => {
          return {
            ...prevState,
            [acc_code]: {
              selectedTab: {
                ...currenAccordionObject[acc_code].selectedTab,
                [`${subAccordionId}${acc_code}`]: true,
              },
            },
          };
        });
      }
    };

    const Data = ({ data2, index }) => {
      return (
        <>
          {" "}
          <Accordion>
            <AccordionHeader>
              <div className="demat_acc_sub_accordion_header">
                <div className="demat_acc_broker_name_wrapper">
                  <div className="folios_image_wrapper">
                    <img src={findAmc(data2?.amc_id)} alt="broker logo" />
                  </div>
                  <p className="broker_name">
                    {data2?.amc_manufacturer?.length > 40
                      ? `${data2?.amc_manufacturer?.slice(0, 40)}...`
                      : data2?.amc_manufacturer}
                  </p>
                  {data2?.amc_manufacturer?.length > 40 && (
                    <img
                      className="info_icon clickable"
                      src={infoIcon}
                      alt="info"
                    />
                  )}
                </div>
                <div className="right_side_data">
                  <div className="dp_id_wrapper">
                    <p className="dp_id_text blueTextColor">Folio Number</p>
                    <p className="dp_id">{data2?.folio_number}</p>
                  </div>

                  {data2?.nomineeList.length !== 0 ? (
                    <div className="nominee_toggle_btn_wrapper">
                      <div className="nominiees_wrapper">
                        <p className="nominiees_text">Nominees</p>
                        <p className="nominiees_number">{`(${data2?.nomineeList?.length})`}</p>
                      </div>

                      {data2?.nomineeList.length !== 0 ? (
                        <div
                          className="toggle_btn_bg buttonBlueBorder"
                          onClick={() =>
                            handleToggleSubAccordion(index, data2?.accountcode)
                          }
                        >
                          <img
                            src={
                              currenAccordionObject[data?.accountcode]
                                ?.selectedTab?.[`${index}${data?.accountcode}`]
                                ? upArrowBlack
                                : downArrowBlack
                            }
                            alt="toggle"
                          />
                        </div>
                      ) : (
                        <div className="toggle_hidden"></div>
                      )}
                    </div>
                  ) : (
                    <div className={!noNominee ? "none" : "minWidth"}></div>
                  )}
                </div>
              </div>
            </AccordionHeader>

            <AccordionContent
              open={
                currenAccordionObject[data?.accountcode]?.selectedTab?.[
                  `${index}${data?.accountcode}`
                ]
              }
            >
              <div className="demat_acc_sub_accordion_content">
                {data2?.nomineeList?.map((nominee, index) => (
                  <div className="person_card">
                    <p className="person_name">{nominee?.name}</p>
                    <CircularProressBar percentage={nominee?.percentage} />
                  </div>
                ))}
              </div>
            </AccordionContent>
          </Accordion>
        </>
      );
    };
    return data.length !== 0 ? (
      <div className="pms_folios_content">
        <div className="mf_folios_header">
          <div className="mf_holding_tabs">
            <Tabs
              onSelect={(value) => {
                handleSubTab(value);
              }}
              selectedTabClass="selected_tab_inside_accordion"
              tabs={[
                {
                  label: "With Holdings",
                  value: "with_hold",
                },
                {
                  label: "Without Holdings",
                  value: "without_hold",
                },
              ]}
            />
          </div>
          <div className="mf_folio_filter_search_container">
            <div
              className="filter_container"
              onClick={() => {
                switch (isSort) {
                  case "asc":
                    setSort("desc");
                    setOrder(false);
                    setwithoutOrder(false);
                    break;
                  case "desc":
                    setSort("asc");
                    setOrder(true);
                    setwithoutOrder(true);
                    break;
                  default:
                    setSort("desc");
                    break;
                }
              }}
            >
              <AToZ fontSize="12px" isSort={isSort} arrowHeight="arrowHeight" />
            </div>

            <div className="search_bar_container">
              <SearchButton2
                search={mfSearch}
                setSearch={(data) => setMfSearch(data)}
                classes={"search_btn_out2"}
                closeBtn={"small"}
              />
            </div>
          </div>
        </div>
        <div className="pms_folios_sub_accordions">
          {subTab.isSelected === true ? (
            holdingsData.length !== 0 ? (
              withHoldData?.filter((eachData, idx) =>
                eachData?.amc_manufacturer
                  ?.toLowerCase()
                  ?.includes(mfSearch?.toLowerCase()?.trim()),
              ).length !== 0 ? (
                holdingsData
                  ?.filter((eachData, idx) =>
                    eachData?.amc_manufacturer
                      ?.toLowerCase()
                      ?.includes(mfSearch?.toLowerCase()?.trim()),
                  )
                  ?.map((data, index) => {
                    return data?.withholdings === subTab.isSelected ? (
                      <Data data2={data} index={index} />
                    ) : (
                      ""
                    );
                  })
              ) : (
                <div className="empty_search">
                  {" "}
                  <img src={noFamilyFound} alt="no_data" />{" "}
                  <h2>No Data Found</h2>
                </div>
              )
            ) : (
              <div className="empty_search">
                {" "}
                <img src={noFamilyFound} alt="no_data" />{" "}
                <h2>You do not have without holding MF folios linked</h2>
              </div>
            )
          ) : withoutHolding.length !== 0 ? (
            withoutHoldData?.filter((eachData, idx) =>
              eachData?.amc_manufacturer
                ?.toLowerCase()
                ?.includes(mfSearch?.toLowerCase()?.trim()),
            ).length !== 0 ? (
              withoutHolding
                ?.filter((eachData, idx) =>
                  eachData?.amc_manufacturer
                    ?.toLowerCase()
                    ?.includes(mfSearch?.toLowerCase()?.trim()),
                )
                ?.map((data, index) => {
                  return data?.withholdings === subTab.isSelected ? (
                    <Data data2={data} index={index} />
                  ) : (
                    ""
                  );
                })
            ) : (
              <div className="empty_search">
                {" "}
                <img src={noFamilyFound} alt="no_data" /> <h2>No Data Found</h2>
              </div>
            )
          ) : (
            <div className="empty_search">
              {" "}
              <img src={noFamilyFound} alt="no_data" />{" "}
              <h2>You do not have without holding MF folios linked</h2>
            </div>
          )}
        </div>
      </div>
    ) : (
      <EmptyContent title={"MF Folios"} />
    );
  };

  const EmptyContent = ({ title }) => {
    return (
      <div className="empty_content_wrapper">
        <img src={noFamilyFound} alt="no_data" />
        <p>{`You do not have any ${title}`}</p>
      </div>
    );
  };

  const getTabContent = (idx, acc_Code) => {
    switch (currenAccordionObject?.[acc_Code]?.selectedTab?.tab) {
      case `${idx}${acc_Code}bankAccount`:
        return (
          <BankAccountAccordionContent
            data={
              bankDetails?.investmentAccountsList?.[
                currenAccordionObject?.[acc_Code]?.selectedTab?.index
              ]?.bankAccountsList
            }
          />
        );
      case `${idx}${acc_Code}loan`:
        return (
          <LoanAccordionContent
            data={
              bankDetails?.investmentAccountsList?.[
                currenAccordionObject?.[acc_Code]?.selectedTab?.index
              ]?.loansList
            }
          />
        );
      case `${idx}${acc_Code}dematAccount`:
        return (
          <DematAccountAccordionContent
            data={
              bankDetails?.investmentAccountsList?.[
                currenAccordionObject?.[acc_Code]?.selectedTab?.index
              ]?.dematAccountsList
            }
          />
        );
      case `${idx}${acc_Code}pmsFolios`:
        return (
          <PMSFoliosAccordionContent
            data={
              bankDetails?.investmentAccountsList?.[
                currenAccordionObject?.[acc_Code]?.selectedTab?.index
              ]?.pmS_Accounts
            }
            title="PMS Folios"
          />
        );
      case `${idx}${acc_Code}aifFolios`:
        return (
          <PMSFoliosAccordionContent
            data={
              bankDetails?.investmentAccountsList?.[
                currenAccordionObject?.[acc_Code]?.selectedTab?.index
              ]?.aiF_Folios
            }
            title="AIF Folios"
          />
        );
      case `${idx}${acc_Code}mfFolios`:
        return (
          <MFFoliosAccordionContent
            data={
              bankDetails?.investmentAccountsList?.[
                currenAccordionObject?.[acc_Code]?.selectedTab?.index
              ]?.foliosList
            }
          />
        );
      default:
        break;
    }
  };

  const handleRemovePhoto = () => {
    const id = selectedUser.userId;

    setIsPicUpdateApiCalled(true);
    ProfileStore2.deleteProfile2({
      pic_id: `${
        ProfileStore2.clientImgUrl
          ? ProfileStore2.clientImgUrl
          : userDetais?.[selectedUser?.index]?.profile_pic
      }`
        .split("blob/")[1]
        .split(".")[0],
      onSuccess: (data) => {
        ProfileStore2.addNewProfilePic(null);
        ProfileStore2.removeClientsPhoto(selectedUser.userId);
        ProfileStore2.getFamilyClients("offloader");
        setIsPicUpdateApiCalled(false);
        setPicUpdateFlow(false);
      },
      onFail: (error) => {
        setIsPicUpdateApiCalled(false);
      },
    });

    setSelectedSet(id);
    setRemovePhotoModal(false);
  };
  const CommonSmallModal = ({
    heading,
    subText,
    mainImgJSX,
    rightBtnText,
    onClickRightBtn,
  }) => {
    return (
      <>
        {isPicUpdateApiCalled && (
          <div className="loader_container">
            <div className="footer_loader_container2">
              <img className="loader_gif" src={loaderGIF} alt="loading..." />
            </div>
          </div>
        )}

        <div>
          <div class="permit_modal_outer ">
            <div class="img_holder1"></div>
            {mainImgJSX}
            <h2 class="permit_heading margin15">{heading}</h2>
            <h6 class="permit_msg">{subText}</h6>
            <div class="permit_btn_div marginbtn45">
              <button
                class="cancel_btn"
                onClick={() => setRemovePhotoModal(false)}
                tabIndex={0}
              >
                Cancel
              </button>
              <h2 class="permit_permission">
                <div class="modalSetRedBtn" onClick={onClickRightBtn}>
                  <label class="per_btn_label2">{rightBtnText}</label>
                  <button class="permit_red_btn">
                    <svg
                      width="10"
                      height="16"
                      viewBox="0 0 10 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 -4.76837e-07L9.88 8L1.88 16Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </h2>
            </div>
          </div>
        </div>
      </>
    );
  };

  const AddImageModalContent = () => {
    const fileRef = useRef();

    const uploadFile = (fileVar) => {
      const file = getSelectedFile(fileVar);
      const validation = validateFile(file);
      switch (validation) {
        case "file type error":
          setUploadMessage({
            message: "Only JPEG and PNG image formats are supported",
            isError: true,
          });
          ProfileStore.updateTempProfile(null);
          break;
        case "file size error":
          setUploadMessage({
            message: "File size larger than 10 MB",
            isError: true,
          });
          ProfileStore.updateTempProfile(null);
          break;
        case "valid file":
          setUploadMessage({
            message: "",

            isError: false,
          });
          ProfileStore2.addNewProfilePic(file);

          break;
        default:
          break;
      }
    };

    const validateFile = (file) => {
      const allowedFileExtention = [".png", ".jpeg", ".jpg"];
      const fileExtention = file.name.substring(file.name.lastIndexOf("."));
      const isFileSizevalid = file.exactSize < 10485760;
      const isFileTypeValid = allowedFileExtention.includes(
        fileExtention.toLowerCase(),
      );
      if (!isFileTypeValid) {
        return "file type error";
      }
      if (!isFileSizevalid) {
        return "file size error";
      }
      if (isFileSizevalid && isFileTypeValid) {
        return "valid file";
      }
    };

    const getFileSize = (size, decimals = 2) => {
      if (size === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(size) / Math.log(k));
      return parseFloat(size / Math.pow(k, i)).toFixed(dm) + " " + sizes[i];
    };

    const getSelectedFile = (file) => {
      if (file) {
        const fileSrc = URL.createObjectURL(file);
        return {
          name: file.name,
          size: getFileSize(file.size),
          exactSize: file.size,
          type: file.type,
          src: fileSrc,
          file: file,
        };
      } else {
        return null;
      }
    };

    const handleFileClick = () => {
      fileRef.current.click();
    };

    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const dt = e.dataTransfer;
      const file = dt.files[0];
      uploadFile(file);
    };

    const hanldeInpuChange = (e) => {
      e.preventDefault();
      const _file = e.target.files[0];
      uploadFile(_file);
    };

    const stopDefault = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const getImageType = (type) => {
      switch (type) {
        case "image/png":
          return "PNG";
        case "image/jpeg":
          return "JPEG";
        case "image/jpg":
          return "JPG";
        default:
          return "";
      }
    };

    const handleUpload = () => {
      if (ProfileStore2.newProfilePic) {
        setIsPicUpdateApiCalled(true);
        setUploadMessage({
          message: "",
          isError: false,
        });
        setIsPictureUpdating(true);
        ProfileStore2.uploadProfile2(
          ProfileStore2.newProfilePic,
          selectedUser.userId,
          {
            onSucess: (data) => {
              setIsPicUpdateApiCalled(false);
              setUploadMessage({
                message: "Profile Picture Updated Successfully",
                isError: false,
              });
              setTimeout(() => {
                setIsPictureUpdating(false);
                ProfileStore2.getFamilyClients("offloader");
                ProfileStore2.updateClientsImgUrl(data.url);
                setUploadMessage({
                  message: "",
                  isError: false,
                });
                ProfileStore2.addNewProfilePic(null);

                setIsUploadSuccess(true);
                setPicUpdateFlow(true);
                setUploadPictureModal(false);
              }, [2000]);
            },
            onFail: (error) => {
              setIsPicUpdateApiCalled(false);
              setIsPictureUpdating(false);
              setUploadMessage({
                message: "Error While Uploading Profile Photo",
                isError: true,
              });
            },
          },
        );
      } else {
      }
    };

    const handleRemove = () => {
      ProfileStore2.addNewProfilePic(null);
      setUploadMessage({
        message: "",
        isError: false,
      });
      setIsUploadSuccess(false);
    };

    const getContentForDashedArea = () => {
      if (ProfileStore2.newProfilePic) {
        return (
          <div className="selected_image_container">
            <img src={imageIcon} alt="icon" />

            <p className="file_details">
              {ProfileStore2.newProfilePic?.name} -{" "}
              {ProfileStore2.newProfilePic?.size}{" "}
              {getImageType(ProfileStore2.newProfilePic?.type)} format
            </p>
            {!isPictureUpdating && (
              <button className="remove_btn" onClick={handleRemove}>
                Remove
              </button>
            )}
          </div>
        );
      } else {
        return (
          <div
            onDragEnter={stopDefault}
            onDragOver={stopDefault}
            onDrop={handleDrop}
            className="drap_and_drop_container_border"
          >
            <div className="drap_and_drop_container">
              <p className="drag_drop_text">Drag and drop your image </p>
              <p className="file_support_text">
                Files Supported: JPEG, PNG and Maximum Size: 10 MB
              </p>
            </div>
            <input
              onChange={hanldeInpuChange}
              type="file"
              accept="image/png, image/jpeg , image/jpg"
              style={{ display: "none" }}
              ref={fileRef}
            />
          </div>
        );
      }
    };

    const checkDisabled = () => {
      return !ProfileStore2.newProfilePic;
    };

    return (
      <>
        {isPicUpdateApiCalled && (
          <div className="loader_container">
            <div className="footer_loader_container2">
              <img className="loader_gif" src={loaderGIF} alt="loading..." />
            </div>
          </div>
        )}
        <div className="add_image_container">
          <div className="default_image_name_wrapper">
            <p className={`message ${uploadMessage.isError ? "red_text" : ""}`}>
              {uploadMessage.message}
            </p>
            <button onClick={handleFileClick}>
              {ProfileStore2.newProfilePic?.src ? (
                <img
                  // onClick={handleFileClick}
                  src={ProfileStore2.newProfilePic?.src}
                  alt="default"
                  className={`${
                    !ProfileStore2.mapUsersData?.[selectedUser?.index]
                      ?.profile_pic
                      ? "cursor_pointer"
                      : !isUploadSuccess
                        ? "cursor_pointer"
                        : ""
                  } clickable`}
                />
              ) : ProfileStore2.currentFamilyMembersImages?.[
                  selectedUser?.userId
                ] &&
                ProfileStore2.currentFamilyMembers?.find(
                  (eachData) => eachData.user_id === selectedUser?.userId,
                )?.profile_pic ? (
                <>
                  <img
                    // onClick={handleFileClick}
                    src={
                      ProfileStore2.currentFamilyMembersImages?.[
                        selectedUser?.userId
                      ]
                    }
                    alt="default"
                    className={`${
                      !ProfileStore2.mapUsersData?.[selectedUser?.index]
                        ?.profile_pic
                        ? "cursor_pointer"
                        : !isUploadSuccess
                          ? "cursor_pointer"
                          : ""
                    } clickable`}
                  />
                </>
              ) : //

              !ProfileStore2.currentFamilyMembersImages?.[
                  selectedUser?.userId
                ] &&
                ProfileStore2.currentFamilyMembers?.find(
                  (eachData) => eachData.user_id === selectedUser?.userId,
                )?.profile_pic ? (
                <div
                  className="no_imgae_portfolio"
                  //onClick={handleFileClick}
                >
                  <p>{userDetais?.[selectedUser?.index]?.full_name?.[0]}</p>
                </div>
              ) : (
                <img
                  // onClick={handleFileClick}
                  src={defaultImgForLiasionAccess}
                  alt="default"
                  className={`${
                    !ProfileStore2.mapUsersData?.[selectedUser?.index]
                      ?.profile_pic
                      ? "cursor_pointer"
                      : !isUploadSuccess
                        ? "cursor_pointer"
                        : ""
                  } clickable`}
                />
              )}
            </button>

            <p className="user_name">{contactDetails?.name}</p>
          </div>
          {getContentForDashedArea()}
          <div className="bottom_button_container">
            {!isPictureUpdating && (
              <ArrowButton
                type="next"
                label={isPicFlowUpdate ? "Save" : "Upload"}
                disabled={checkDisabled()}
                onClick={handleUpload}
              />
            )}
          </div>
        </div>
      </>
    );
  };

  const handleClose = () => {
    setUploadPictureModal(false);
    setUploadMessage({
      message: "",
      isError: false,
    });
  };

  const handleOpenImgModal = () => {
    ProfileStore2.addNewProfilePic(null);
    setUploadPictureModal(true);
  };

  const handleTabsSelection = (data, accountCode) => {
    setCurrenAccordionObject((prevState) => {
      return {
        ...prevState,
        [accountCode]: {
          selectedTab: {
            tab: data.tab,
            index: data.index,
          },
        },
      };
    });
  };

  useEffect(() => {
    ProfileStore2?.mapUsersData?.[selectedUser?.index]?.profile_pic
      ? setPicUpdateFlow(true)
      : setPicUpdateFlow(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (document.documentElement.clientWidth < 1026) {
      setIsTab(true);
    }
    // eslint-disable-next-line
  }, [document.documentElement.clientWidth]);

  return (
    <div className="user_profile_details_container">
      <div className="user_profile_details">
        {/* image  */}
        <div className="img_cntnr">
          {PerformanceStore.loaderClosingCheckForImage?.[
            `${selectedUser?.userId}3`
          ] &&
          PerformanceStore.loaderClosingCheckForImage?.[
            `${selectedUser?.userId}3`
          ] === "pending" ? (
            <div className="skeleton"></div>
          ) : (getDecodedToken()?.user_type === "manager" &&
              UserStore.singleUsersUrl) ||
            ProfileStore2.currentFamilyMembersImages?.[selectedUser?.userId] ? (
            <img
              className="img1"
              src={
                getDecodedToken()?.user_type !== "manager"
                  ? ProfileStore2.currentFamilyMembersImages?.[
                      selectedUser?.userId
                    ]
                    ? ProfileStore2.currentFamilyMembersImages?.[
                        selectedUser?.userId !== undefined
                          ? selectedUser?.userId
                          : ""
                      ]
                    : ProfileStore2.newProfilePic
                  : UserStore.singleUsersUrl
              }
              alt={data?.title}
            />
          ) : (
            <div className="no_no_image">
              {" "}
              <NoImage
                data={userDetais?.[selectedUser?.index]?.full_name?.[0]}
                noImageClass={"no_image_component_profile"}
              />
            </div>
          )}
          {getDecodedToken()?.user_type === "customer" &&
            String(userDetais?.[selectedUser?.index]?.user_id) ===
              getCookie("selectedUsersId") && (
              <UploadProfileTooltip>
                {" "}
                <ul className="camera_tooltip_listitems">
                  <li
                    className="camera_tooltip_listitem upload_photo_btn_animation"
                    onClick={() => handleOpenImgModal()}
                  >
                    <div className="change_image_wrapper">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.14147 0.512594C6.44171 0.512594 6.72105 0.667356 6.88007 0.922326L7.46855 1.8656H8.38513C8.71862 1.8656 9.03846 1.99808 9.27427 2.2339C9.51009 2.46971 9.64257 2.78955 9.64257 3.12304V7.95935C9.64257 8.29284 9.51009 8.61268 9.27427 8.84849C9.03846 9.08431 8.71862 9.21679 8.38513 9.21679H1.6143C1.2808 9.21679 0.960969 9.08431 0.725153 8.84849C0.489337 8.61268 0.356857 8.29284 0.356857 7.95935V3.12304C0.356857 2.78955 0.489337 2.46971 0.725153 2.2339C0.960969 1.99808 1.2808 1.8656 1.6143 1.8656H2.60826L3.14257 0.94554C3.2191 0.813764 3.32889 0.704386 3.46095 0.628342C3.593 0.552298 3.74271 0.512252 3.8951 0.512207H6.14108L6.14147 0.512594ZM4.99971 3.22093C4.43534 3.22093 3.89408 3.44512 3.49501 3.8442C3.09593 4.24327 2.87174 4.78453 2.87174 5.3489C2.87174 5.91328 3.09593 6.45454 3.49501 6.85361C3.89408 7.25268 4.43534 7.47688 4.99971 7.47688C5.56409 7.47688 6.10535 7.25268 6.50442 6.85361C6.90349 6.45454 7.12769 5.91328 7.12769 5.3489C7.12769 4.78453 6.90349 4.24327 6.50442 3.8442C6.10535 3.44512 5.56409 3.22093 4.99971 3.22093ZM4.99971 3.80128C5.41017 3.80128 5.80381 3.96434 6.09404 4.25457C6.38428 4.54481 6.54733 4.93845 6.54733 5.3489C6.54733 5.75936 6.38428 6.153 6.09404 6.44324C5.80381 6.73347 5.41017 6.89652 4.99971 6.89652C4.58926 6.89652 4.19562 6.73347 3.90538 6.44324C3.61515 6.153 3.45209 5.75936 3.45209 5.3489C3.45209 4.93845 3.61515 4.54481 3.90538 4.25457C4.19562 3.96434 4.58926 3.80128 4.99971 3.80128Z"
                          fill="white"
                        />
                        <path
                          d="M4.99942 3.80127C5.40987 3.80127 5.80351 3.96432 6.09375 4.25456C6.38398 4.54479 6.54703 4.93843 6.54703 5.34889C6.54703 5.75934 6.38398 6.15299 6.09375 6.44322C5.80351 6.73345 5.40987 6.89651 4.99942 6.89651C4.58896 6.89651 4.19532 6.73345 3.90508 6.44322C3.61485 6.15299 3.4518 5.75934 3.4518 5.34889C3.4518 4.93843 3.61485 4.54479 3.90508 4.25456C4.19532 3.96432 4.58896 3.80127 4.99942 3.80127Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <span className="change_image_text">
                      {" "}
                      Upload Profile Image
                    </span>
                  </li>

                  {getDecodedToken()?.user_type === "customer" &&
                    String(userDetais?.[selectedUser?.index]?.user_id) ===
                      getCookie("selectedUsersId") &&
                    ProfileStore2.currentFamilyMembersImages?.[
                      selectedUser?.userId
                    ] && (
                      <li
                        className="camera_tooltip_listitem remove_photo_btn_animation"
                        onClick={() => setRemovePhotoModal(true)}
                      >
                        <div className="remove_photo_wrapper">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.41667 3.25293L3 8.6696"
                              stroke="white"
                              stroke-width="1.625"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M3 3.25293L8.41667 8.6696"
                              stroke="white"
                              stroke-width="1.625"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <span className="remove_photo_text">Remove Photo</span>
                      </li>
                    )}
                </ul>
              </UploadProfileTooltip>
            )}
        </div>
        <div className="user_name_cntnr">
          <div>
            <h2>{contactDetails?.name}</h2>
            {userDetais?.[selectedUser?.index]?.isprimary && (
              <p>
                <span className="blueBgtColor">PRIMARY</span>
              </p>
            )}
          </div>

          <p className="tool">
            <span>Account Since</span>
            <span> {getDisplayDate(bankDetails?.inceptionDate)}</span>
          </p>
        </div>
      </div>
      {/* Accound Details */}
      <div className="account_registered_container">
        <h2 className="section_heading">Accounts Registered With Us</h2>
        {bankDetails?.investmentAccountsList.length ? (
          <div className="main_accordions_container">
            {bankDetails?.investmentAccountsList?.map((rowData, index) => (
              <Accordion id={index} key={index}>
                <AccordionHeader>
                  <div className="profile_main_accordion_header_container">
                    <div className="header_icon_heading_wrapper">
                      <div className="header_icon_wrapper">
                        <img
                          src={
                            rowData?.type?.includes("Executionary")
                              ? excu_acc
                              : account_registered
                          }
                          alt="account"
                        />
                      </div>
                      <div className="header_heading_subheading_wrapper">
                        <p className="header_heading_text">{rowData?.name}</p>
                        <p
                          className={`header_subheading_text ${
                            rowData?.type?.includes("Executionary")
                              ? "is-yellow"
                              : "is-green"
                          }`}
                        >
                          {rowData?.type === "POA"
                            ? "Power of Attorney"
                            : rowData?.type}{" "}
                          Account
                        </p>
                      </div>
                    </div>
                    <div className="broking_code_wrapper">
                      <p className="broking_code_text blueTextColor">
                        Broking Code &nbsp;&nbsp;
                        <span>{rowData?.broking_code}</span>
                      </p>
                      <div
                        className="arrowBtn_wrapper portfolio_button_animation buttonBlueBorder"
                        onClick={() =>
                          handleToggleAccordion(
                            rowData?.accountcode,
                            index,
                            rowData,
                          )
                        }
                      >
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {currentOpenAccordion === rowData?.accountcode ? (
                            <svg
                              width="13"
                              height="8"
                              viewBox="0 0 13 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.05629 2.77309L6.70312 2.42069L6.34996 2.77309L2.11351 7.00031L1.41023 6.29703L6.70312 1.00414L11.996 6.29703L11.2927 7.00031L7.05629 2.77309Z"
                                stroke="#404040"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="13"
                              height="8"
                              viewBox="0 0 13 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.05629 5.23081L6.70312 5.58321L6.34996 5.23081L2.11351 1.0036L1.41023 1.70687L6.70312 6.99977L11.996 1.70688L11.2927 1.0036L7.05629 5.23081Z"
                                stroke="#404040"
                              />
                            </svg>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </AccordionHeader>
                <AccordionContent
                  //old code
                  //open={currentOpenAccordion === rowData?.accountcode}
                  open={currenAccordionObject[rowData?.accountcode]}
                >
                  {rowData?.aiF_Folios?.length === 0 &&
                  rowData?.bankAccountsList?.length === 0 &&
                  rowData?.dematAccountsList?.length === 0 &&
                  rowData?.foliosList?.length === 0 &&
                  rowData?.loansList?.length === 0 &&
                  rowData?.pmS_Accounts?.length === 0 ? (
                    <div className="empty_search addMarginBottom">
                      {" "}
                      <img src={noFamilyFound} alt="no_data" />{" "}
                      <h2>No Data Found</h2>
                    </div>
                  ) : (
                    <div className="profile_accordion_content">
                      <div className="tabs_inside_accordion">
                        <Tabs
                          onSelect={(value) => {
                            handleTabsSelection(
                              { tab: value, index: index },
                              rowData?.accountcode,
                            );
                          }}
                          selectedTabClass="selected_tab_inside_accordion"
                          tabs={[
                            {
                              label: `Bank Account (${getAccountsLength(
                                rowData?.bankAccountsList?.length,
                              )})`,
                              value: `${index}${rowData?.accountcode}bankAccount`,
                              forRenderCondition: getAccountsLength(
                                rowData?.bankAccountsList?.length,
                              ),
                            },
                            {
                              label: `Demat Account (${getAccountsLength(
                                rowData?.dematAccountsList?.length,
                              )})`,
                              value: `${index}${rowData?.accountcode}dematAccount`,
                              forRenderCondition: getAccountsLength(
                                rowData?.dematAccountsList?.length,
                              ),
                            },
                            {
                              label: `MF Folios (${getAccountsLength(
                                rowData?.foliosList?.length,
                              )})`,
                              value: `${index}${rowData?.accountcode}mfFolios`,
                              forRenderCondition: getAccountsLength(
                                rowData?.foliosList?.length,
                              ),
                            },
                            {
                              label: `Loan (${getAccountsLength(
                                rowData?.loansList?.length,
                              )})`,
                              value: `${index}${rowData?.accountcode}loan`,
                              forRenderCondition: getAccountsLength(
                                rowData?.loansList?.length,
                              ),
                            },
                            {
                              label: `PMS Folios (${getAccountsLength(
                                rowData?.pmS_Accounts?.length,
                              )})`,
                              value: `${index}${rowData?.accountcode}pmsFolios`,
                              forRenderCondition: getAccountsLength(
                                rowData?.pmS_Accounts?.length,
                              ),
                            },
                            {
                              label: `AIF Folios (${getAccountsLength(
                                rowData?.aiF_Folios?.length,
                              )})`,
                              value: `${index}${rowData?.accountcode}aifFolios`,
                              forRenderCondition: getAccountsLength(
                                rowData?.aiF_Folios?.length,
                              ),
                            },
                          ]}
                          renderCondition={true}
                          selectedTab={
                            currenAccordionObject?.[rowData?.accountcode]
                              ?.selectedTab?.tab
                          }
                        />
                        <div className="tab_content">
                          {getTabContent(index, rowData?.accountcode)}
                        </div>
                      </div>
                    </div>
                  )}
                </AccordionContent>
              </Accordion>
            ))}
          </div>
        ) : (
          <div
            style={{
              margin: "20px 0 0 0",
              fontSize: "17px",
            }}
            className="no-data-text"
          >
            No Active account present under this client
          </div>
        )}
      </div>
      {/* contact details */}
      <div className="user_contact_details">
        <h2 className="section_heading">Contact Details</h2>
        <div className="detail_cntnr">
          <div className="left_side">
            <div className="first_child">
              <CardContact
                photo={contactEmail}
                type={"email"}
                content={contactDetails?.email}
              />
            </div>
            <div className="sec_child">
              <CardContact
                photo={contactAddress}
                type={"address"}
                content={`${contactDetails?.address?.line1} ${contactDetails?.address?.line2} ${contactDetails?.address?.line3}, ${contactDetails?.address?.city},  ${contactDetails?.address?.state}, ${contactDetails?.address?.country} , ${contactDetails?.address?.pincode}`}
              />
            </div>
          </div>
          <div className="right_side">
            <div className="first_child">
              <CardContact
                photo={contactPhone}
                type={"phone"}
                content={contactDetails?.mobile}
              />
            </div>

            <div className="sec_child">
              <CardContact
                photo={contactLandline}
                type={"landline"}
                content={contactDetails?.landline_phone}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Family office team */}
      {la_officer && (
        <div className="users_liaison_officer_details">
          <h2 className="section_heading">{`${familyOfficeTeamNameText} Details`}</h2>
          <div className="liasonss_details">
            {la_officer?.profile_pic && ProfileStore2.liaison_img ? (
              <img
                src={
                  ProfileStore2.liaison_img !== null
                    ? ProfileStore2.liaison_img
                    : ""
                }
                alt="officer"
              />
            ) : (
              <NoImage
                data={la_officer?.full_name?.split(" ")?.[0][0]}
                noImageClass={"no_image_liaison"}
              />
            )}

            <div className="all_details">
              <div>
                <h2>{la_officer?.full_name}</h2>
                <h2 className="blueTextColor">{familyOfficeTeamNameText}</h2>
              </div>
              <div>
                <h2>
                  <img src={settingPhone2} alt="ph" /> {la_officer?.phoneNo}
                </h2>
                <h2 className="liaison_email">
                  <img src={settingMail3} alt="em" />

                  {la_officer?.emailId}
                </h2>
              </div>
            </div>
            <a className="mailto" href={`mailto:${la_officer?.emailId}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="55"
                height="55"
                viewBox="0 0 55 55"
                fill="none"
              >
                <rect
                  width="55"
                  height="55"
                  rx="20"
                  fill="#C59331"
                  stroke="#C59331"
                  strokeWidth={1}
                />
                <path
                  d="M18.3332 18.3335H36.6665C37.9269 18.3335 38.9582 19.3647 38.9582 20.6252V34.3752C38.9582 35.6356 37.9269 36.6668 36.6665 36.6668H18.3332C17.0728 36.6668 16.0415 35.6356 16.0415 34.3752V20.6252C16.0415 19.3647 17.0728 18.3335 18.3332 18.3335Z"
                  fill="white"
                  stroke="#C59331"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M38.9582 20.6252L27.4998 28.6461L16.0415 20.6252"
                  fill="white"
                />
                <path
                  d="M38.9582 20.6252L27.4998 28.6461L16.0415 20.6252"
                  stroke="#C59331"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
      )}

      <Modal
        onClose={handleClose}
        open={uploadPictureModal}
        title={
          isPicFlowUpdate ? `Update Profile Picture` : `Upload Profile Picture`
        }
        width={"800px"}
        showCloseIcon={!isPictureUpdating}
      >
        <AddImageModalContent />
      </Modal>
      <Modal
        onClose={() => setRemovePhotoModal(false)}
        open={removePhotoModal}
        width="438px"
        minWidth="438px"
        modalContainerClass="disable_liasion_access_modal"
      >
        <CommonSmallModal
          heading="Remove profile picture?"
          subText={`You can add image again by clicking on the change  profile image button in your profile`}
          mainImgJSX={
            <div className="normal_img">
              <img
                src={
                  ProfileStore2.currentFamilyMembersImages?.[
                    selectedUser?.userId
                  ]
                }
                alt="user"
              />
            </div>
          }
          rightBtnText="Yes, Remove"
          onClickRightBtn={() => handleRemovePhoto()}
        />
      </Modal>
    </div>
  );
};

export default observer(ProfileDetails);
